import request from '@onefootprint/request';
import type { AssumeRoleResponse } from '@onefootprint/request-types/dashboard';
import { useMutation } from '@tanstack/react-query';
import { DASHBOARD_AUTHORIZATION_HEADER } from '@/config/constants';

const assumeRole = async ({ tenantId, authToken }: { tenantId: string; authToken: string }) => {
  const response = await request<AssumeRoleResponse>({
    method: 'POST',
    url: '/org/auth/assume_role',
    headers: {
      [DASHBOARD_AUTHORIZATION_HEADER]: authToken,
    },
    data: { tenantId },
  });
  return response.data;
};

const useAssumeRole = () =>
  useMutation({
    mutationFn: assumeRole,
  });

export default useAssumeRole;
